import axios from "axios";

export default class SettingApi {
  static getBaseURl() {
    return process.env.REACT_APP_PUBLIC_URL;
  }

  static async update({ token, examId, interview_rubrics }) {
    const url = `${this.getBaseURl()}/exam/${examId}/update/settings`;
console.log(examId,token,interview_rubrics);
    const requestBody = {
    interview_rubrics // Ensure it's structured correctly as per API requirements
    };
 
    try {
      const response = await axios.put(url, requestBody, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return { status: 200, data: response};
    } catch (error) {
      throw error;
    }
  }

  static async getDefaultValue(name){
    const url = `${this.getBaseURl()}/config/${name}`;
    try{
      const response = await axios.get(url);

      return { status: 200, data: response.data };
    }
    catch(error){
      throw error;
    }
  }
}
